// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueTruncate from 'vue-truncate-filter'
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import { DatePicker, List, Button, Card, Row, Col, Radio, Input, Tag, Divider } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css' // or 'ant-design-vue/dist/antd.less'
import './assets/main.css';

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueTruncate)
Vue.use(VueResource)
Vue.use(VueMoment)

// for ant design
Vue.use(DatePicker)
Vue.use(List)
Vue.use(Button)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Tag)
Vue.use(Divider)

// Vue.prototype.$hostname = 'http://localhost:3000'
Vue.prototype.$hostname = 'http://vod-qa-dashboard.mixd.tv:3000'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.filter('percentage', function (value, decimals) {
  if (!value) value = 0
  if (!decimals) decimals = 0

  value = value * 100
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%'
})



// WEBPACK FOOTER //
// ./src/main.js